// client/src/coms/settings/sections/PrivacySettings.js
// Personal Settings → Privacy & Security: your status (incl. appear offline, with a duration), end-to-end encryption, and the moderation actions you
// received with appeals.
import React from 'react';
import { Section } from '../../personalisation/settingsControls';
import MyModeration from '../../serveradmin/MyModeration';
import E2eeSettings from '../../e2ee/E2eeSettings';
import E2eeReportsPanel from '../../e2ee/E2eeReportsPanel';
import PresenceStatusSetting from '../../presence/PresenceStatusSetting';

export default function PrivacySettings() {
  return (
    <Section id="vx-cat-privacy" title="Privacy & Security" description="Your status (online, AFK, Do Not Disturb or appear offline), end-to-end encryption, and the moderation decisions that affect you.">
      <PresenceStatusSetting />
      <E2eeSettings />
      <E2eeReportsPanel />
      <div id="vx-setting-moderation" data-setting="moderation" className="vx-set-block">
        <h4 className="vx-set-subtitle">Moderation & appeals</h4>
        <p className="vx-set-hint">Warnings, timeouts, kicks and bans you have received in any server, with the reason given. Appeals are private between you and that server’s moderators.</p>
        <MyModeration />
      </div>
    </Section>
  );
}
